var render = function render(){var _vm=this,_c=_vm._self._c;return _c('widget-settings-item',{attrs:{"title":_vm.$t('settings.defaultTimeRange')}},[_c('c-quick-date-interval-type-field',{attrs:{"name":_vm.name,"ranges":_vm.intervalRanges},model:{value:(_vm.value),callback:function ($$v, $$p) {_vm.$updateField([], $$v, undefined)},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }